<template>
    <div class="feedback-body" :style="`background-image:url(${feedback})`">
        <div class="msg-area">
            <div class="msg-title">
                世界各国からお客様の声
            </div>
            <div class="msg">
                Kaiteki TVを体験された世界中の <br/>
                お客様よりメッセージをいただいています。
            </div>
            <div class="more-btn">
                More
            </div>
            <div class="user-area">
                <div class="user-introduction">
                    <div class="user-image">
                        <img :src="feedbackList[activatedIndex].userImage" />
                    </div>
                    <div class="user-introduction-msg">
                        <div class="introduction" v-html="feedbackList[activatedIndex].userMsg">
                        </div>
                        <!-- <div class="use-for">
                            {{ feedbackList[activatedIndex].useFor }}
                        </div> -->
                    </div>
                </div>
                <div class="main-evaluate">
                    {{ feedbackList[activatedIndex].title }}
                </div>
                <div class="evaluate"  v-html="feedbackList[activatedIndex].msg">
                </div>
                
            </div>
            
        </div>
        <div class="btn-group">
            <div class="last-btn" @click="last()">
                <img :src="left" />
            </div>
            <div class="next-btn" @click="next()">
                <img :src="right" />
            </div>
        </div>
    </div>
</template>
<script>
import feedback from '../../../images/feedback.png'
import left from '../../../images/left.png'
import right from '../../../images/right.png'
import feedbackList from '../../../js/feedback'
export default {
    data () {
        return {
            activatedIndex: 0,
            feedback,
            left,
            right,
            feedbackList
        }
    },
    methods: {
        last () {
            if (this.activatedIndex - 1 < 0) {
                this.activatedIndex = this.feedbackList.length -1
            } else {
                this.activatedIndex -= 1
            }
        },
        next () {
            if (this.activatedIndex + 1 >= this.feedbackList.length) {
                this.activatedIndex =  0
            } else {
                this.activatedIndex += 1
            }
        }
    }
}
</script>
<style scoped>
.feedback-body {
    width: 100%;
    box-sizing: border-box;
    color: #fff;
    position: relative;
    margin-top: 10px;
    height: auto;
    
    background-color: #000;
    margin-bottom: 10px;
    background-size: 100%;
    background-position: 0 0;
    background-repeat: no-repeat;
}
.bg-image {
    display: block;
    width: 100%;
}
.msg-area {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 10px;
    padding-bottom: 40px;
    padding-top: 60px;
}
.msg-title {
    font-size: 26px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #FFFFFF;
    text-align: center;
}
.msg {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    margin-bottom: 100px;
}
.more-btn {
    position: absolute;
    top: 175px;
    right: 20px;
    width: 85px;
    height: 85px;
    background: #FFFFFF;
    border-radius: 50%;
    font-size: 20px;
    font-family: ITC Avant Garde Gothic Std;
    font-weight: bold;
    color: #FDB819;
    line-height: 85px;
    text-align: center;
    box-shadow: 0px 0px 0px 10px rgba(255,255,255,0.2);
    animation: shadowHeartJump 1.5s ease-out infinite;
}
.user-area {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
}
@keyframes shadowHeartJump
{
    0% {
        box-shadow: 0px 0px 0px 0px rgba(255,255,255,0.5)
    }
    100% {
        box-shadow: 0px 0px 0px 20px rgba(255,255,255,0);
    }
}
.user-introduction {
    width: 100%;
    display: flex;
    /* justify-content: space-between; */
    margin-bottom: 30px;
}
.user-image img {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    display: block;
    margin-right: 10px;
}
.user-introduction-msg {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #FCFCFC;
    line-height: 22px;
}
.main-evaluate {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #FDB819;
    line-height: 22px;
    margin-bottom: 10px;
}
.evaluate {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #BFBFBF;
    line-height: 24px;
    margin-bottom: 20px;
}
.btn-group {
    width: 80px;
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.btn-group img{
    width: 27.5px;
    height: 27.5px;
    display: block;
}
</style>